export const API_URL = 'https://server.myballleague.com';
// export const API_URL = 'http://localhost:1337';
